import {html, PolymerElement} from '@polymer/polymer/polymer-element.js';
import '@polymer/paper-dropdown-menu/paper-dropdown-menu.js';
import '@polymer/paper-listbox/paper-listbox.js';
import '@polymer/paper-item/paper-item.js';
import '@cbar/cbar-shared-styles/cbar-shared-styles.js';
import '@cbar/localizemixin/LocalizeMixin.js';
import '@polymer/paper-spinner/paper-spinner.js';
import {afterNextRender} from "@polymer/polymer/lib/utils/render-status";
import '@polymer/gold-phone-input/gold-phone-input.js';
import {AsYouType, getCountryCallingCode} from 'libphonenumber-js/max';
import {countries} from '@cbar/countries-list';
/**
 * `cbar-country-phone-select`
 *
 *
 * @customElement
 * @polymer
 * @demo demo/index.html
 */
class CbarCountryPhoneSelect extends Cbar.LocalizeMixin(PolymerElement){
  static get template() {
    return html`
        <style include="cbar-shared-styles">
            :host {
                display: block;
            }
            .country-row, .row{
                display: flex;
                width: 100%;
            }
            .spaced {
                padding-left: 5px;
                flex: 3;
            }
            paper-listbox {
                max-width: 100%;
            }
            .country-number{
                color: grey;
                padding-left: 5px;
            }
            paper-dropdown-menu{
                flex: 2
            }
        </style>

        <div class="row">
            <paper-dropdown-menu no-animations horizontal-align="center" vertical-align="top" required$="[[required]]" id="country-dropdown">
                <paper-listbox slot="dropdown-content" attr-for-selected="value" selected="{{country}}" on-selected-item-changed="__handleSelectedChanged" id="country-select">
                    <paper-item id="loading-item" disabled hidden$="[[!processing]]"><paper-spinner active></paper-spinner></paper-item>
                    <template is="dom-repeat" items="[[listedCountries]]" as="listedCountry">
                        <paper-item value="[[listedCountry]]"><div class="country-row"><span>[[listedCountry.title]]</span></div></paper-item>
                    </template>
                </paper-listbox>
            </paper-dropdown-menu>
            <div class="spaced">
                <gold-phone-input value="{{number}}" disabled$="[[!country]]" country-code="{{countryCode}}" autocomplete="tel-local" required="[[required]]"></gold-phone-input>
            </div>

            <form>
                <input name="mobile" type="hidden" value="[[value]]">
                <button type="submit" hidden></button>
            </form>
        </div>
    `
  }
  static get properties() {
    return {
      country : {
        type: Object,
        value: false,
        notify: true
      },
      listedCountries : {
        type: Array,
        value: false
      },
      processing: {
        type: Boolean,
        value: false
      },
      number: {
        type: String,
        value: ''
      },
      value: {
        type: String,
        computed: '',
        notify: true
      },
      required: {
        type: Boolean,
        value: false,
        observer: "__handleRequired"
      }
    };
  }

  static get observers(){
    return [
      '__formatValue(country, number)',
      '__setValue(number, countryCode)',
      '__handleCountryChanged(country, listedCountries)'
    ]
  }

  constructor(){
    super();

    afterNextRender(this, () => {
      this.__setupCountryDisplay();
    });
  }

  get phoneInput(){
    if(!this.__phoneInput){
      this.__phoneInput = this.root.querySelector('gold-phone-input')
    }
    return this.__phoneInput;
  }


  get validatableElements(){
    if(!this.__validatableElements){
      this.__validatableElements = this.root.querySelectorAll('paper-dropdown-menu, gold-phone-input');
    }
    return this.__validatableElements;
  }

  get countryDropdown(){
    if(!this.__countrySelect){
      this.__countrySelect = this.root.querySelector('#country-dropdown');
    }
    return this.__countrySelect;
  }

  get countrySelect(){
    if(!this.__countrySelect){
      this.__countrySelect = this.root.querySelector('#country-select');
    }
    return this.__countrySelect;
  }

  __setValue(number, code){
    if(!number || !code){
      this.value = '';
      return;
    }

    this.value = `+${code}${number.replace(/-/g,"")}`;
  }

  /**
   * get the countries from countries-list package and format them into an array that the DOM-REPEAT can handle
   * @private
   */
  __setupCountryDisplay(){
    this.processing = true;
    let countryArray = [];

    // get all countries
    Object.entries(countries).forEach((country, i) => {
      // extract data we need
      countryArray.push({
        code: country[0],
        title: country[1].name
      });
    });

    //TODO: Localize these or use native property instead of name and not sort?
    //alphabetical ordering
    countryArray.sort((a,b) => {
      return a.title > b.title ? 1 : -1;
    });

    this.processing = false;
    this.listedCountries =  countryArray;
  }


  /**
   * fire the object out of the element that can be handled
   * @param e
   * @private
   */
  __handleSelectedChanged(e){
    if(!e.detail.value){
      return
    }

    this.set('country', e.detail.value.value);

    this.phoneInput.countryCode = getCountryCallingCode(this.country.code);

    this.phoneInput.focus();
  }

  __formatValue(country, number){
    // checking to see if this is firing due to our format

    if(!this.number || number === this.currentValue){
      return;
    }

    //create a new as you type object to track when we put the number in
    let asYouType = new AsYouType(this.country.code);
    this.countryCode = getCountryCallingCode(this.country.code);
    asYouType.input(`+${this.countryCode}${number}`);

    let template = asYouType.formatter.template;

    if(!template){
      return;
    }

    // create the template for the input to use
    template = template.substr(template.indexOf(' ')+1);
    template = template.split(' ').join('-').toUpperCase();

    this.phoneInput.set('phoneNumberPattern', template);

    //reformat our number
    this.currentValue = this.phoneInput.value;
    this.phoneInput.value = '';
    requestAnimationFrame(() => {
      this.phoneInput.value = this.currentValue.split(' ').join('-');
    })
  }


  validate(){
    let isValid = true;
    this.validatableElements.forEach(element => {
      if(!element.validate() && isValid){
        isValid = false;

        if(element.value !== undefined) {
          element.errorMessage = element.value.length === 0 ? "Required" : "Invalid";
        } else {
          element.errorMessage = !element.contentElement.selected ? "Required" : "Invalid";
        }

      }
    });

    return isValid;
  }

  __handleCountryChanged(country, countries){
    if(!countries || !country){
      return;
    }

    let index = this.listedCountries.findIndex(findCountry => findCountry.code == country.code);

    if(index !== -1){
      requestAnimationFrame(() => {
        this.countrySelect.selectIndex(index + 1);
        this.countryCode = this.phoneInput.countryCode;
        requestAnimationFrame(() => {
          this.__formatValue(country, this.number);
        })
      });
    }
  }

  __handleRequired(required){
    requestAnimationFrame(() => {
      this.countryDropdown.label = required ? `${this.localize('Country')} *` : this.localize('Country');
      this.phoneInput.label = required ? `${this.localize('Mobile Number')} *` : this.localize('Mobile Number');
    })
  }

}

window.customElements.define('cbar-country-phone-select', CbarCountryPhoneSelect);
